import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DataSearchResult } from '../../enums/enums'

@Component({
  selector: 'ddc-search-result-figure',
  templateUrl: './ddc-search-result-figure.component.html',
  styleUrl: './ddc-search-result-figure.component.scss',
  imports: [CommonModule, AngularMaterialsModules],
})
export class DdcSearchResultFigureComponent {
  @Input() result!: DataSearchResult
  @Input() showIcon: boolean = true
  @Input() showTime: boolean = true
  @Output() figureClick = new EventEmitter<DataSearchResult>()

  onFigureClick(): void {
    this.figureClick.emit(this.result)
  }
}
